import { getConfig } from './config/five9ChatConfig'
import { startCheckingState } from './five9ChatSurvey'
import { render } from 'react-dom'
import { ChatButton } from "./ChatButton"
import { Five9AllConfig } from './config/five9-typings'

declare const FIVE9_ENV: string
declare const Five9SocialWidget: any
declare const isMobile: any;

export type InitializeChatParams = {
  locale: string;
  country?: string;
}

export type InitializeChatResponse = {
  isLocaleSupported: boolean
  isChatLoaded: boolean
}

function loadChat(config: Five9AllConfig ): boolean {
  try {
    const style = document.createElement('style');
    style.innerText = "@media screen and (max-width: 767px) { .five9-header { text-align: right; } }";
    document.head.appendChild(style)

    const script = document.createElement('script')
    script.setAttribute('src', 'https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js')
    script.onload = () => {
      isMobile.any = false;
      Five9SocialWidget.addWidget(config)

      if (config.defaultProfile != undefined) {
        const realButton = document.getElementById('five9-maximize-button')!
        realButton.style.display = 'none';
        const fakeButton = document.createElement('div')
        render(<ChatButton defaultProfile={config.defaultProfile} onLanguageSelected={onLanguageSelected} />, fakeButton)
        realButton.parentNode!.parentNode!.appendChild(fakeButton)
      }
    }
    document.body.appendChild(script)

    return true
  } catch (e) {
    logException('Error: Five9 Widget not loaded!')
    return false
  }
}

function onLanguageSelected(profile: string): void {
  Five9SocialWidget.removeWidget();
  const config = getConfig(profile)
  isMobile.any = false;
  Five9SocialWidget.addWidget(config);
  startCheckingState(config!.vivrURL!) // config will be always not null
  const realButton = document.getElementById('five9-maximize-button')!
  realButton.click();
}

export function initializeChat({ locale, country }: InitializeChatParams) {
  return new Promise<InitializeChatResponse>((resolve, reject) => {
    const result = { isLocaleSupported: false, isChatLoaded: false }
    try {
      // Check if it's NFR market
      let nfrCountryCode: string | undefined;
      if (locale == 'en-US' && country && country != 'USA') { 
        nfrCountryCode = country;
      }
      logMessage(`initializeChat for locale: ${locale}, NFR Country:${nfrCountryCode}`)
      const config = getConfig(locale, nfrCountryCode)
      if (config) {
        if (country && country == 'USA') {
          config.showProfiles = false;
        }
        result.isLocaleSupported = true
        result.isChatLoaded = loadChat(config)
        if (result.isChatLoaded) {
          startCheckingState(config.vivrURL!)
          hideBoldChatIfExists()  
        }
      } else {
        logMessage(`Five9 Chat does not support locale: ${locale}`)
      }
      resolve(result)
    } catch (e) {
      logException('Five9 Chat was not initialized!')
      reject({ isChatLoaded: result })
    }
  })
}

function logMessage(message: string): void {
  if (typeof FIVE9_ENV !== 'undefined' && FIVE9_ENV !== 'prod') console.log('[five9-chat-nonprod]', message)
}

function logException(message: string): void {
  console.error('[five9-chat-exception]', message)
}

function hideBoldChatIfExists(): void {
  const mainSiteBoldChat = document.querySelectorAll('a[href*="livechat.boldchat.com"]')
  if (mainSiteBoldChat) {
    mainSiteBoldChat.forEach(a => a.remove())
  }
}

export function removeFive9Widget() {
  Five9SocialWidget.removeWidget(); 
}